import React from 'react'

class Break extends React.Component {
    constructor(props) {
        super(props)
    }

    render() {
        return (
            <div className="ci-break-container" style={this.props.style}>
                <div className="ci-break-text-wrapper">
                    <div className="ci-break-title ci-font-h3">
                        {this.props.children ? this.props.children : ""}
                    </div>
                </div>
                <div className="ci-break" />
            </div>
        );
    }

}

export default Break